import { Network } from "../../.."

export class UserHistory {
	static async getUserHistory(userId) {
		const response = await Network.AxiosWrapperV2.get({
			url: `/user/history/${userId}`
		})

		return response?.data
	}
}

export default UserHistory
